import { width } from "@mui/system";
import React, { useEffect, useState } from "react";

const FModal = ({
  title = "",
  isOpen = false,
  okButton = false,
  okButtonTitle = "Ok",
  okButtonAction = () => {},
  cancelButton = false,
  cancelButtonTitle = "Cancelar",
  cancelButtonAction = () => {},
  modalWidth = "max-w-6xl",
  modalColor = "bg-white",
  onClickOut = () => {},
  closeButton = true,
  closeButtonTitle = true,
  okButtonclassName = null,
  closeButtonAction = () => {},
  body = null,
}) => {
  return (
    <>
      {isOpen ? (
        <>
          <div
            className="justify-center  items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            onClick={onClickOut}
          >
            <div className={`relative w-auto my-6 p-5 mx-auto ${modalWidth}`}>
              {/*content*/}
              <div
                className={`border-0 rounded-lg shadow-lg relative flex flex-col w-full ${modalColor} outline-none focus:outline-none`}
              >
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-slate-700 text-2xl font-semibold">
                    {title}
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={closeButtonAction}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      CLOSE
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <p className="my-4 text-slate-500 text-lg leading-relaxed">
                    {body}
                  </p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b ">
                  {cancelButton == true ? (
                    <button
                      className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={cancelButtonAction}
                    >
                      {cancelButtonTitle}
                    </button>
                  ) : null}

                  {okButton == true ? (
                    <button
                      className={
                        !okButtonclassName
                          ? "w-100 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                          : okButtonclassName
                      }
                      type="button"
                      onClick={okButtonAction}
                    >
                      {okButtonTitle}
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default FModal;
